import React from "react";
import { useHistory } from "react-router";
import { TelemetryService } from "../services/TelemetryService";
import { useEffect } from "react";
import { useUser } from "../utilities/useUser";
import { useAppConfig } from "../utilities/useAppConfig";
import { getDataLayer } from "../utilities/Tracking/DataLayer"

declare const gtag: (command: string, commandParameters?: any, additionalConfigInfo?: any) => any;

export default function AnalyticsPageTracker(props: React.PropsWithChildren<{}>) {
	const history = useHistory();

	const userInfo = useUser();
	const { onlineUser } = userInfo;

	const [appConfig] = useAppConfig();
	const { trackingId: mikesGoogleAnalyticsTrackingId, isEnabled: mikesGoogleAnalyticsEnabled } = appConfig.mikesGoogleAnalytics;
	const { trackingId: googleAnalyticsTrackingId, isEnabled: googleAnalyticsEnabled } = appConfig.googleAnalytics;

	useEffect(() => {
		const dataLayer = getDataLayer();
		(window as any).gtag = function () {
			dataLayer.push(arguments);
		};

		if (googleAnalyticsEnabled) {
			let script = document.createElement("script");
			script.type = "text/javascript";
			script.async = true;
			script.src = `https://www.googletagmanager.com/gtag/js?id=${googleAnalyticsTrackingId}`;
			document.getElementsByTagName("head")[0].appendChild(script);
		}

		if (mikesGoogleAnalyticsEnabled) {
			let script = document.createElement("script");
			script.type = "text/javascript";
			script.async = true;
			script.src = `https://www.googletagmanager.com/gtag/js?id=${mikesGoogleAnalyticsTrackingId}`;
			document.getElementsByTagName("head")[0].appendChild(script);
		}

		gtag("js", new Date());

		gtag("config", googleAnalyticsTrackingId, { send_page_view: false });
		gtag("config", googleAnalyticsTrackingId, { page_path: window.location.pathname + window.location.search });

		gtag("config", mikesGoogleAnalyticsTrackingId, { send_page_view: false });
		gtag("config", mikesGoogleAnalyticsTrackingId, { page_path: window.location.pathname + window.location.search });
	}, [mikesGoogleAnalyticsEnabled, mikesGoogleAnalyticsTrackingId, googleAnalyticsEnabled, googleAnalyticsTrackingId]);

	useEffect(() => {
		function recordPageChange(pathname: string, search: string) {
			gtag("config", googleAnalyticsTrackingId, { page_path: pathname + search });

			if (mikesGoogleAnalyticsEnabled) {
				gtag("config", mikesGoogleAnalyticsTrackingId, { page_path: pathname + search });
			}

			if (onlineUser) {
				TelemetryService.recordUserActivity();
			}
		}

		return history.listen((location) => recordPageChange(location.pathname, location.search));
	}, [history, mikesGoogleAnalyticsEnabled, mikesGoogleAnalyticsTrackingId, googleAnalyticsTrackingId, onlineUser]);

	return <>{props.children}</>;
}
